import { ActionType } from 'typesafe-actions';
import BaseReducer, {
	baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import * as shoppingCenterActions from './shoppingCenterActions';
import { IShoppingCenterType } from '../../types/IShoppingCenterType';

export type ShoppingCenterAction = ActionType<typeof shoppingCenterActions>;

export interface IShoppingCenterStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IShoppingCenterType };
	readonly queries: { [queryKey: string]: IShoppingCenterType[] };
}

export function shoppingCenterReducer(
	state = baseInitialState as IShoppingCenterStateType,
	action: ShoppingCenterAction,
) {
	const Reducer = new BaseReducer('shoppingCenterReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			default:
				return innerState;
		}
	});
}
